export default {
    diesel: 'Diesel',
    electric: 'Electric',
    gasoline: 'Gasoline',
    hybrid: 'Hybrid',
};
